/** Search-index entries for navagraha study-sheet topics (5.2–5.10). */
import { GRAHA_GUIDE_HUB } from './jyotishaGrahaGuides';
import { GRAHA_GUIDE_TOPICS } from './jyotishaGrahaGuideTopics';

const GRAHA_SEARCH_TERMS = {
  sun: 'surya suraj soul father vitality atman king authority ravivaar sunday उच्च मेष नीच तुला',
  moon: 'chandra chandrama mind mother emotion waxing waning paksha monday somvaar cancer karka',
  mars: 'mangal kuja courage anger heat warrior tuesday mangalvaar aries mesha scorpio',
  mercury: 'budh budha speech trade commerce intellect wednesday budhvaar gemini mithuna virgo kanya',
  jupiter: 'guru brihaspati wisdom dharma teacher expansion thursday guruvar sagittarius dhanu pisces meena',
  venus: 'shukra shukr harmony arts love comfort friday shukravaar taurus vrishabha libra tula',
  saturn: 'shani sani time duty karma discipline saturday shanivaar capricorn makara aquarius kumbh',
  rahu: 'rahu north node shadow craving obsession unconventional smoke eclipse chhaya graha',
  ketu: 'ketu south node moksha detachment past life insight spirituality chhaya graha',
};

export const GRAHA_GUIDE_SEARCH_INDEX = GRAHA_GUIDE_TOPICS.map((t) => ({
  id: t.id,
  groupLabel: 'ग्रह (Planets)',
  tabLabel: t.tabEn,
  terms: [
    t.id,
    t.slug,
    t.grahaKey,
    t.hi,
    t.en,
    t.roman,
    GRAHA_GUIDE_HUB[t.grahaKey]?.blurb ?? '',
    'graha navagraha planet karaka significator mitra shatru friendship drishti dignity exaltation debilitation',
    GRAHA_SEARCH_TERMS[t.slug] ?? '',
  ].join(' '),
}));

export const GRAHA_GUIDE_READ_MINUTES = Object.fromEntries(
  GRAHA_GUIDE_TOPICS.map((t) => [t.id, 10]),
);

export const GRAHA_GUIDE_ICONS = Object.fromEntries(
  GRAHA_GUIDE_TOPICS.map((t) => [t.id, GRAHA_GUIDE_HUB[t.grahaKey]?.emoji ?? '🪐']),
);
